import styled from 'styled-components'

import { Navbar } from '@sketch/components'

export const NavbarItem = styled.div`
  display: flex;
  margin: 0 8px;

  & + & {
    margin-left: 0;
  }
`

export const Wrapper = styled.div`
  display: inline-flex;
  gap: 4px;

  ${/* sc-selector */ NavbarItem}:first-child {
    margin-left: 0px;
  }
`

/** Its own gap would add to the back button's, so it gives it up. */
export const EmbeddedHeaderSection = styled(Navbar.Section)`
  gap: 0;
`

/**
 * The back arrow's slot in the embedded header.
 *
 * The same size and the same 8px gap as `LayoutHeaderBackButton`, which is
 * what sits the arrow beside the logo in every other view. This header is a
 * portal into the same navbar, so the spacing has to be repeated here rather
 * than inherited.
 */
export const BackButtonItem = styled.div`
  margin: 0 8px 0 0;
  line-height: 1;
`
